module.exports = __webpack_public_path__ + "img/banner01.15f1fdda.jpg";